import React, { createContext } from "react";

export interface TutorialContextValue {
    currentStep: number; // 0-based index
    isCardDismissed: boolean;
    showReopenHint: boolean; // shows hint on navbar button after dismissal

    open: () => void; // re-opens card (clears dismissal and resets step)
    openFirstTime: () => void; // opens only if tutorial hasn't been auto-shown before
    goTo: (index: number) => void;
    dismissCard: () => void; // dismiss the card until reopened
    clearReopenHint: () => void; // clear the reopen hint
}

export const TutorialContext = createContext<TutorialContextValue | undefined>(undefined);
